import { lazy } from 'react';
import { D as DefaultTranslationComp } from './en-US-DnXq2BgW.js';

/* eslint-disable quotes, quote-props, comma-dangle, max-len */
// eslint-disable-next-line @typescript-eslint/no-unused-vars

const translationImports = {
  'ar-AE': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--ar-AE" */'./ar-AE-9czv7_U7.js'),
  'de-DE': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--de-DE" */'./de-DE-B8Tqi2TV.js'),
  'en-AU': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--en-AU" */'./en-AU-CzRhrjj2.js'),
  'en-CA': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--en-CA" */'./en-CA-BXhubdPD.js'),
  'en-GB': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--en-GB" */'./en-GB-BL3ZhEYF.js'),
  'en-IN': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--en-IN" */'./en-IN-BH_LVCt1.js'),
  'en-SG': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--en-SG" */'./en-SG-Cl6YR8qv.js'),
  'es-CO': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--es-CO" */'./es-CO-5HC6BX_U.js'),
  'es-ES': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--es-ES" */'./es-ES-JZRkytfh.js'),
  'es-MX': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--es-MX" */'./es-MX-BTMb2YFG.js'),
  'fr-CA': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--fr-CA" */'./fr-CA-BVGc1U6x.js'),
  'fr-FR': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--fr-FR" */'./fr-FR-QBntaMzx.js'),
  'hi-IN': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--hi-IN" */'./hi-IN-BaXjLQ2H.js'),
  'it-IT': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--it-IT" */'./it-IT-Bxh3B-E9.js'),
  'ja-JP': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--ja-JP" */'./ja-JP-C1TOssz_.js'),
  'ko-KR': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--ko-KR" */'./ko-KR-B3wLDZ_3.js'),
  'nl-NL': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--nl-NL" */'./nl-NL-CLECViTA.js'),
  'pl-PL': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--pl-PL" */'./pl-PL-CF81yR3o.js'),
  'pt-BR': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--pt-BR" */'./pt-BR-aPMeXI5e.js'),
  'sv-SE': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--sv-SE" */'./sv-SE-sMAqOr2P.js'),
  'ta-IN': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--ta-IN" */'./ta-IN-UKWyraB7.js'),
  'th-TH': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--th-TH" */'./th-TH-CL_NgObq.js'),
  'tr-TR': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--tr-TR" */'./tr-TR-BV-WqAk9.js'),
  'vi-VN': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--vi-VN" */'./vi-VN-C0nlBiGv.js'),
  'zh-CN': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--zh-CN" */'./zh-CN-DyBKwRDa.js'),
  'zh-TW': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--zh-TW" */'./zh-TW-epFSaLjP.js')
};
const translationComps = Object.entries(translationImports).reduce((acc, [localCode, importFn]) => ({
  ...acc,
  [localCode]: /*#__PURE__*/lazy(importFn)
}), {});
function getTranslationComponent(locale) {
  return {
    component: locale && locale in translationComps ? translationComps[locale] : DefaultTranslationComp,
    locale: locale && locale in translationComps ? locale : 'en-US',
    translationImports
  };
}

export { getTranslationComponent as g };
//# sourceMappingURL=index-BmD8Abdb.js.map
